import { BiTrash } from 'react-icons/bi'
import { KEY_CODE_ESCAPE, classBt, classbtAzul, classbtColunasVermelho } from '../../Utils/Types'
import React, { useEffect } from 'react'
import { MdOutlinePersonOff } from 'react-icons/md'


type Props = {
    visible: boolean
    loading?: boolean
    buttonConfirmClick?: () => void,
    closeModalEvent: () => void
}

export const ModalCancelarIdentificacao = React.memo(({ visible, loading, buttonConfirmClick, closeModalEvent }: Props) => {

    useEffect(() => {

        if (visible) {

            let modal = document.getElementById('modal_alertCancelIdentificacao')
            let modalContent = document.getElementById('modal_content_alertCancelIdentificacao')

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-400px]')
                    modalContent.classList.add('mt-24')
                }
            }

        } else {

            let modal = document.getElementById('modal_alertCancelIdentificacao')
            let modalContent = document.getElementById('modal_content_alertCancelIdentificacao')

            if (modal) {
                modal.style.visibility = 'hidden'

                if (modalContent) {
                    modalContent.classList.add('mt-[-400px]')
                    modalContent.classList.remove('mt-24')
                }
            }

        }

    }, [visible])

    useEffect(() => {

        const handleKeyPressESC = (event: any) => {
            if (event.code === KEY_CODE_ESCAPE && visible) {

                closeModalEvent()
            }
        }

        document.addEventListener('keydown', handleKeyPressESC)

        return () => {
            document.removeEventListener('keydown', handleKeyPressESC)

        }
    }, [visible])

    const handleConfirmClick = () => {

        if (buttonConfirmClick) {
            buttonConfirmClick()
        }
    }

    return (

        <div id="modal_alertCancelIdentificacao" style={{ visibility: "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40`}>

            <div id="modal_content_alertCancelIdentificacao" className={`relative flex flex-col w-[85%] sm:w-[70%] md:w-[60%] lg:w-[40%] xl:w-[30%] h-[250px] bg-white dark:bg-slate-600 rounded-lg mt-[-400px] transition-all duration-300 justify-center items-center`}>

                <div className={`absolute top-0 flex flex-row w-full h-[70px] items-center`}>

                    <div className={`mx-auto flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full bg-[#8f3838] border-2 border-[#FC5F4D] shadow-sm shadow-black mt-6 mb-4`}>
                        <MdOutlinePersonOff className={`text-red-400 w-9 h-9`} />
                    </div>

                </div>

                <div className={`absolute top-[70px] bottom-[60px] w-full pt-4`}>

                    <div >
                        <span className={`flex justify-center text-base font-semibold text-slate-800 dark:text-slate-200`}>Cancelar a identificação do cliente?</span>
                    </div>

                    <div className={`mt-1 mb-6 w-full h-auto px-2`}>
                        <p className={`text-base text-center text-slate-500 dark:text-slate-100 pl-2 pr-2 w-full h-auto flex justify-center items-center`}>Tem certeza que deseja cancelar essa identificação?</p>
                    </div>

                </div>

                <div className={`absolute bottom-0 w-full h-[60px] flex items-center justify-end bg-slate-100 dark:bg-slate-600 border border-slate-200 dark:border-slate-500 border-x-0 border-b-0 py-4 px-3 rounded-b-lg space-x-3`}>

                    <button
                        onClick={closeModalEvent}
                        className={`${classbtColunasVermelho} max-w-[150px]`}>
                        NÃO
                    </button>

                    <button
                        onClick={handleConfirmClick}
                        className={`${classbtAzul} ${classBt} max-w-[150px]`}>
                        {loading &&
                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                            </div>
                        }
                        {!loading ? `SIM` : `AGUARDE`}
                    </button>

                </div>

            </div>

        </div>

    )

})